import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function compareAsJSON<T>(a: T, b: T): boolean {
	try {
		return JSON.stringify(a) === JSON.stringify(b);
	} catch (error) {
		console.error("Error comparing objects as JSON:", error);
		return false;
	}
}

export function isInstantBetween(
	compared: Temporal.Instant | Temporal.ZonedDateTime,
	older: Temporal.Instant | Temporal.ZonedDateTime | null,
	newer: Temporal.Instant | Temporal.ZonedDateTime | null,
): boolean {
	const duration1 = older ? compared.since(older.toString()) : { sign: -1 };
	const duration2 = newer ? compared.since(newer.toString()) : { sign: 1 };
	return duration1.sign >= 0 && duration2.sign <= 0;
}

export function visualizarGramos(gramos: number): string {
	let unit;
	let convertedValue;
	const validUnits = Intl.supportedValuesOf("unit");

	// If the value is 0, return "0 g". Less than 5μg (5*e−6) is considered 0.
	if (Math.round(gramos * 1_000_000) == 0) {
		return "0 g";
	}

	if (Math.abs(gramos) >= 1000) {
		unit = "kilogram";
		convertedValue = gramos / 1000;
	} else if (Math.abs(gramos) < 1) {
		unit = "mg";
		convertedValue = gramos * 1000;
	} else {
		unit = "gram";
		convertedValue = gramos;
	}

	// If the browser supports the unit, format it with the inlt API
	if (validUnits.includes(unit))
		return convertedValue.toLocaleString("es-ES", {
			style: "unit",
			unit: unit,
			minimumFractionDigits: 0,
			minimumSignificantDigits: 1,
			maximumSignificantDigits: 4,
		});
	const localizedValue = convertedValue.toLocaleString("es-ES", {
		minimumFractionDigits: 0,
		minimumSignificantDigits: 1,
		maximumSignificantDigits: 4,
	});

	// if the value is 1000 or more, round to the nearest whole number
	if (convertedValue >= 1000) return `${localizedValue} ${unit}`;

	// if the value is 100 or more, round to one decimal place
	if (convertedValue >= 100) return `${localizedValue} ${unit}`;

	// if the value is 10 or more, round to two decimal places
	if (convertedValue >= 10) return `${localizedValue} ${unit}`;

	// otherwise, return the value with three decimal places
	return `${localizedValue} ${unit}`;
}
